module.exports = __webpack_public_path__ + "static/media/deli@3x.b0e1eae5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/deli@3x.png
// module id = 663
// module chunks = 1